import { ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import {
  acceptAnalyticsConsent,
  declineAnalyticsConsent,
  getAnalyticsConsent,
} from "./analytics";
import { translations, type Language } from "./game/i18n";

export function CookieConsentBanner({ elevated = false, lang }: { elevated?: boolean; lang: Language }) {
  const [visible, setVisible] = useState(false);
  const t = translations[lang];

  useEffect(() => {
    setVisible(getAnalyticsConsent() === null);
  }, []);

  if (!visible) {
    return null;
  }

  function accept() {
    acceptAnalyticsConsent();
    setVisible(false);
  }

  function decline() {
    declineAnalyticsConsent();
    setVisible(false);
  }

  return (
    <section className={`cookie-banner ${elevated ? "elevated" : ""}`} aria-label={t.cookieBannerLabel}>
      <div className="cookie-banner-copy">
        <ShieldCheck size={18} aria-hidden="true" />
        <div>
          <strong>{t.cookieBannerTitle}</strong>
          <p>{t.cookieBannerBody}</p>
        </div>
      </div>
      <div className="cookie-banner-actions">
        <button className="cookie-button secondary" type="button" onClick={decline}>
          {t.cookieDecline}
        </button>
        <button className="cookie-button primary" type="button" onClick={accept}>
          {t.cookieAccept}
        </button>
      </div>
    </section>
  );
}
